import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Transmission() {
	return (
		<div>
			<NeonHero
				title="Transmission Services"
				subtitle="Rebuilds, replacements, and fluid service. AI ensures the right parts, at the right price, fast."
				primaryCta={{ label: 'Get Quote', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">Highlights</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Automatic and manual transmission diagnostics</li>
					<li>Clutch, flywheel, torque converter</li>
					<li>Seals, solenoids, valve bodies</li>
					<li>Warranty-backed installs at our hubs</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Road test and thermal checks</li>
							<li>Scan data and pressure line testing</li>
							<li>Unit repair or replacement at hub</li>
							<li>Adaptation learning and validation</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Affirm and Klarna available at checkout. 0% APR for 12 months with approved credit.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Fluid & service: same-day. Replacements/rebuilds: 2–5 days depending on availability.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
